import { render, staticRenderFns } from "./reviews.vue?vue&type=template&id=b261cd24&scoped=true&"
import script from "./reviews.vue?vue&type=script&lang=js&"
export * from "./reviews.vue?vue&type=script&lang=js&"
import style0 from "./reviews.vue?vue&type=style&index=0&id=b261cd24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b261cd24",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseTestimonialsVideo: require('/home/runner/work/webpage/webpage/components/base/testimonials-video/testimonials-video.vue').default,ReviewsUserReviews: require('/home/runner/work/webpage/webpage/components/reviews/user-reviews/user-reviews.vue').default,BaseMembersStories: require('/home/runner/work/webpage/webpage/components/base/members-stories/members-stories.vue').default,ReviewsPressQuotes: require('/home/runner/work/webpage/webpage/components/reviews/press-quotes/press-quotes.vue').default,AreaFaqs: require('/home/runner/work/webpage/webpage/components/area/faqs/faqs.vue').default})
